(function($){
	"use strict";
	var filter;
	var hash = location.hash;
	
	var staffGrid = [];
	
	var removeHash = function  () { 
	    var scrollV, scrollH, loc = window.location;
	    if ( "pushState" in history ) {
	        history.pushState("", document.title, loc.pathname + loc.search);
	    }
	    else {
	        // Prevent scrolling by storing the page's current scroll offset
	        scrollV = document.body.scrollTop;
	        scrollH = document.body.scrollLeft;
	
	        loc.hash = "";
	
	        // Restore the scroll offset, should be flicker free
	        document.body.scrollTop = scrollV;
	        document.body.scrollLeft = scrollH;
	    }
	};
	
	var filterStaffClick = function ( e ){
		e.preventDefault();
		
		filter = $( this ).data( 'filter' );
		
		if ( filter === 'all' ) {
			filter = undefined;
			removeHash(); //location.hash = '';
		} 
		
		// only show relevant staff members
		filterStaffDirectory();
	};
	
	var filterStaffDirectory = function (){
		var loc = window.location;
		$( 'div.staff-row' ).html( '' );
		console.log( 'Filter', filter );
		if ( typeof filter !== 'undefined' ) {
			location.hash = filter;
			if ("pushState" in history) {
		        history.pushState("", document.title, loc );
		    }
		}
		$.map( staffGrid, function( staff ){
			if ( staff.hasClass( 'filter-' + filter ) || typeof filter === 'undefined' ){
				$( 'div.staff-row' ).append( staff );
			}
		} );
	};
	
	var initalFilter = function(){
		if ( hash.length ) {
			console.log( hash.substring( 1 ) );
			// if the hash is a relevant group filter it.
			
			if ( $( 'a.filter-region.filter-' + hash.substring( 1 ) ).length ) {
				filter = hash.substring( 1 );
				filterStaffDirectory();
			}
		}
	};
	
	$( document ).ready( function(){
		$( 'ul#staff-region-filter a.filter-region' ).on( 'click', filterStaffClick );
		
		$( '.staff-post-block' ).each(function(){
			staffGrid.push( $( this ).clone() );
		});
		
		initalFilter();
		
		
	} );
	
})(jQuery);